import React, { Component } from "react";
import Row from "reactstrap/lib/Row";
import Col from "reactstrap/lib/Col";
import { Button } from 'reactstrap';
import ApiEndpoints from "../../../constants/api_endpoints";
import InputFeild from "../../global/form/input"
import SelectList from "../../global/form/select"
import "../../../styles/button.css"
import {Icon, Switch, Tooltip} from '@material-ui/core';
import store from "../../../store";
import { setError, setSuccess, setLoader } from "../../../actions/action-creators";
import RichTextEditor from "../../global/form/Richtext";
import { Collapse, CardBody, Card } from 'reactstrap';
import ConfirmAction from "../../global/confirm-action";
import CONSTANTS from "../../../constants";
import moment from "moment";

class JobClientLink extends Component {
    constructor(props) {
      super(props);
      this.state = {
            clientList: [],
            isOpenAddLink : false,
            linkList : [] ,
            isConfirm : false,
            isShowInactiveLinks: false
        }
    }

    async componentDidMount(){
         this.fetchClients();
        await this.init() ;
    }

    init = async ( props ) =>{
        let { isShowInactiveLinks = false } = props || {};
        store.dispatch(setLoader(true));
        try{
            let body = {job_id : this.props.job.job_id};
            if(isShowInactiveLinks) body.is_active = [0, 1];
            let apiData = await ApiEndpoints.Jobs.fetchClientLink(body);
            this.setState({linkList : apiData.data.data, isShowInactiveLinks}) ;
        }
        catch(e){
            store.dispatch(setError({show: true, message: e.response ? e.response.data.message : e.toString()}))
        }
        store.dispatch(setLoader(false))
    }

     fetchClients = async () => {
      store.dispatch(setLoader(true))
        try{
            let companyResp = await ApiEndpoints.Invoice.fetchClients();
            this.setState({clientList : companyResp.data.data});
        }
        catch(e){
            store.dispatch(setError({show: true, message: e.response ? e.response.data.message : e.toString()}))
        }
        store.dispatch(setLoader(false))

    }


    onChangeAddLink = (key , value) => {
        let {isOpenAddLink} = this.state ;  
        isOpenAddLink[key] = value ;
        this.setState({isOpenAddLink}) ;
    }

    addClientLink = async (e) => {
        e.preventDefault();
        let {isOpenAddLink} = this.state;
        store.dispatch(setLoader(true))
        try{
            var body = {
                job_id : this.props.job.job_id,
                link_type: isOpenAddLink.link_type,
                title: isOpenAddLink.title,
                client_id: isOpenAddLink.client_id,
                client_link: isOpenAddLink.client_link,
                link_config : "{}",
                user_level: isOpenAddLink.user_level || 0
            }
            if(isOpenAddLink.job_location_id) body.job_location_id = isOpenAddLink.job_location_id
            await ApiEndpoints.Jobs.addClientLink(body);
            this.setState({isOpenAddLink : false}) ;
            this.init();
        }
        catch(e){
          store.dispatch(setError({show: true, message: e.response ? e.response.data.message : e.toString()}))
        }
        store.dispatch(setLoader(false))
    }

    deleteLink = async ({job_client_link_id}) => {
        store.dispatch(setLoader(true))
        try{
            await ApiEndpoints.Jobs.deleteClientLink({job_client_link_id});
            await this.init()
        }
        catch(e){
            store.dispatch(setError({show: true, message: e.response ? e.response.data.message : e.toString()}))
        }
        store.dispatch(setLoader(false))
    }
    
    render(){
        let { isOpenAddLink , linkList , isConfirm, clientList} = this.state;
        let { job } = this.props;
        let jobLocationsById = (job.JobLocations || []).reduce((prev , curr) => { prev[curr.job_location_id] = curr; return prev; }, {})
        return(
            <div>
                <Row>
                    <Col>
                        <Button className="buttonred" style={{height: "23px", paddingTop: "1px" }} onClick={() => {this.setState({isOpenAddLink : isOpenAddLink ? false : {}})}}>Add Link</Button>
                    </Col>
                    <Col className="text-right">
                        <span className="small">Show deleted links?</span>
                        <Switch
                            onChange={(e) => this.init({ isShowInactiveLinks: e.target.checked }) }
                            checked={this.state.isShowInactiveLinks}
                            size="small"
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Collapse className="w-100" isOpen={!!isOpenAddLink}>
                            <Card className="mt-3">
                               <CardBody>
                                <form onSubmit={this.addClientLink}>
                                    <Row>
                                        <Col xs={3}>
                                            <SelectList id="select_state" placeholder="Select Type" value={isOpenAddLink.link_type || ""} onChange={(e) => this.onChangeAddLink("link_type", e.target.value)}>
                                                <option value={"UTM"}>Client Tracking Link</option>
                                                <option value={"GENERAL"}>General Link</option>
                                            </SelectList>
                                        </Col>
                                        <Col xs={2.5}>
                                            <SelectList selectAll="All Location"  placeholder="Select Location" value={isOpenAddLink.job_location_id || ""} onChange={(e) => this.onChangeAddLink("job_location_id", e.target.value)}>
                                                {(job.JobLocations || []).map(loc => <option value={loc.job_location_id}>{loc.city}, {loc.state}</option>)}
                                            </SelectList>
                                        </Col>
                                        <Col xs={2}>
                                            <InputFeild required placeholder="Link Title" value={isOpenAddLink.title || ""} onChange={(e) => this.onChangeAddLink("title", e.target.value)} />
                                        </Col>
                                        <Col xs={3}>
                                            <SelectList search={true} selectAll="Client"  placeholder="Select client" value={isOpenAddLink.client_id || ""} onChange={(e) => this.onChangeAddLink("client_id", e.target.value)}>
                                               
                                                {clientList.map(client => <option key={client.client_id} value={client.client_id}>{client.client_name}</option>)}
                                                               
                                            </SelectList>    
                                        </Col>
                                        <Col xd={1}>
                                            <SelectList selectAll="All Partners" placeholder="Select Partner Type" onChange={(e) => this.onChangeAddLink("user_level", e.target.value)} value={isOpenAddLink.user_level}>
                                                {[1, 2, 3, 4, 5, 6].map(userLevel =>  <option key={userLevel} value={userLevel}>Partner Level {userLevel}</option>)}
                                            </SelectList>
                                        </Col>
                                    </Row>
                                    <Row className="mt-3">
                                        <Col xs={12}>
                                            <InputFeild required multiline rows={3} value={isOpenAddLink.client_link || ""} placeholder="Link URL" onChange={(e) => this.onChangeAddLink("client_link", e.target.value)}/>
                                        </Col>
                                    </Row>
                                    
                                    <Row className="mt-3">
                                        <Col>
                                            <Button type="button" color="secondary" className="float-right" onClick={()=> {this.setState({isOpenAddLink : false})}} style={{fontSize: "12px",height: "23px", paddingTop: "1px"}}>Cancel</Button>
                                            <Button className="buttonred float-right mr-2" style={{height: "23px", paddingTop: "1px"}}>Save</Button>
                                        </Col>
                                    </Row>
                                </form>
                                </CardBody>
                            </Card>
                        </Collapse>
                    </Col>
                </Row>

            {linkList.map((link , i)=>
            <div key={i} style={{fontSize: "14px"}} className="border bg-light p-2 mt-3 shadow-sm">
                <Row className="">
                    <Col xs={10}>
                        <span className="d-block font-weight-bold">{link.link_type} | {link.title} | {link.client_name}</span>
                        {!!link.job_location_id && <span className="d-block small">Location: {jobLocationsById[link.job_location_id] ? jobLocationsById[link.job_location_id].city+", "+jobLocationsById[link.job_location_id].state : "Deleted Location"}</span>}
                        {!!link.user_level && <span className="d-block small text-danger font-weight-bold">Partner Level {link.user_level}</span>}
                        <span className="" style={{wordBreak: "break-word"}}>{link.client_link}</span>
                    </Col>
                                 
                    <Col xs={2} className="text-right">
                        {Number(link.is_active) ? 
                            <Icon className="ml-2" onClick={()=> {this.setState({isConfirm :  () => this.deleteLink(link)})}} style={{cursor: "pointer", fontSize: "16px"}}>delete</Icon>
                            :
                            <span className="bg-danger small text-light px-2 py-1" style={{borderRadius: 20}}>Deleted</span>
                        }
                        <span className="d-block text-muted small">{moment(link.created_on).format("Do MMM'YY HH:mm")}</span>
                    </Col>
                </Row>
            </div>
            )
            }
            <ConfirmAction isOpen={!!isConfirm} onClose={() => this.setState({isConfirm : false})} callback={isConfirm} />
                        
        </div>
        


        );
    }
}

export default JobClientLink;